import { lazy } from "react";

const Dashboard = lazy(() => import("./List/Dashboard"));

export { Dashboard };
